/**
 * The ledger stores a wrapped-up master trade as `Settled`; the business calls that
 * state "Closed" (LOS-5334). The rename is display-only — contracts, stored filter
 * values and every status comparison still work off `Settled` — so the translation
 * happens at the point of render.
 *
 * Master trades only: a sub-trade's own terminal status stays "Settled".
 */
export const MASTER_TRADE_SETTLED_STATUS = 'Settled'
export const MASTER_TRADE_CLOSED_LABEL = 'Closed'

/**
 * A sub-trade's own terminal status for a manual Terminate (LOS-5338). It exists only at
 * sub-trade level — a master trade is never itself "Terminated" in the Trade Status filter's
 * sense — so filtering on it asks about a trade's sub-trades (LOS-7001).
 */
export const SUB_TRADE_TERMINATED_STATUS = 'Terminated'

export const masterTradeStatusLabel = (status?: string | null): string =>
  status === MASTER_TRADE_SETTLED_STATUS ? MASTER_TRADE_CLOSED_LABEL : (status ?? '')
